/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
/* eslint-disable-next-line import/prefer-default-export */
/**
 * @description SDK流水日志上报
 * @author aprilcai
 * @see atta地址: http://atta.pcg.com/#/dataManage/myData/attaIdDetail?attaid=0b400015260
 * @see 鹰眼地址: http://log.webdev.com/mylog/logQuery/lid/100557
 */
import { detect } from './detect';
import { stringify } from './querystring';
import cookies from './cookies';

const { osType, osVersion, browserType, browserVersion, appType, appVersion, ua } = detect();
const createFlowId = () => {
  let id = '';
  for (let i = 1; i <= 32; i++) {
    const n = Math.floor(Math.random() * 16.0).toString(16);
    id += n;
  }
  return id;
};
const flowId = createFlowId(); // 用于标记新页面打开生成的日志

const baseReportInfo = {
  attaid: '0b400015260',
  token: '3374738622',
  os_type: osType,
  os_version: osVersion,
  browser_type: browserType,
  browser_version: browserVersion,
  app_type: appType,
  app_version: appVersion,
  ua,
  hh_ref: getHref(),
};

let seqNum = 0;

// 解决微信小游戏location报错问题
function getHref() {
  try {
    if (location.href) {
      return location.href;
    }
    return '';
  } catch (err) {
    return err;
  }
}

export const reportSdkFlow = (data: {
  api_method?: string;
  api_param?: string;
  api_code?: string | number;
  api_result?: string;
  api_type?: string;
  api_cost_time?: string | number;
  sdk_version?: string;
  vid?: string;
  cid?: string;
  ext_param?: string;
} = {
  api_method: '',
  api_param: '',
  api_code: '',
  api_result: '',
  api_type: '',
  api_cost_time: '',
  sdk_version: '',
  vid: '',
  cid: '',
  ext_param: '',
}) => {
  seqNum += 1;
  const userData = {
    hh_pvid: cookies.getItem('pvid') || '',
    hc_main_login: cookies.getItem('main_login') || '',
    hc_uin: cookies.getItem('uin') || cookies.getItem('luin') || '',
    hc_openid: cookies.getItem('openid') || '',
    hc_vuserid: cookies.getItem('vuserid') || cookies.getItem('vqq_vuserid') || '',
    s_omgid: cookies.getItem('video_omgid') || '',
    s_guid: cookies.getItem('guid'),
  };
  const sdkData = {
    flowid: flowId,
    seqnum: seqNum,
    client_time: new Date().getTime(),
  };
  const image = new Image();
  const reportData = { ...baseReportInfo, ...userData, ...sdkData, ...data };
  image.src = `//h.trace.qq.com/kv?${stringify(reportData).replace(/^\?/, '')}`;
};
